import React, { useState } from "react";
import Categories from "./categories";
import TemplatesManager from "./TemplatesManager";
import { useStores } from "../../stores";
import { rolesWithId } from "../../constants/constants";

export default function AwakenTables() {
  const { clientsStore } = useStores();
  const [activeTab, setActiveTab] = useState("fundOptions"); // 'fundOptions' | 'templates'

  // Only admins can see this page (same rule as Categories)
  if (clientsStore.user?.role !== rolesWithId.admin) {
    return null;
  }

  return (
    <div className="p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">Awaken Tables</h1>

      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-6" aria-label="Tabs">
          <button
            type="button"
            onClick={() => setActiveTab("fundOptions")}
            className={`whitespace-nowrap pb-3 border-b-2 text-sm font-medium ${
              activeTab === "fundOptions"
                ? "border-blue-500 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            Fund Options
          </button>
          <button
            type="button"
            onClick={() => setActiveTab("templates")}
            className={`whitespace-nowrap pb-3 border-b-2 text-sm font-medium ${
              activeTab === "templates"
                ? "border-blue-500 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            Templates
          </button>
        </nav>
      </div>

      {activeTab === "fundOptions" && (
        <div>
          <Categories />
        </div>
      )}

      {activeTab === "templates" && (
        <div>
          <TemplatesManager />
        </div>
      )}
    </div>
  );
}


